// menuStorage.js
const MENU_STORAGE_KEY = 'menuItems';

export const getMenuItems = () => {
  const storedMenuItems = sessionStorage.getItem(MENU_STORAGE_KEY);
  if (storedMenuItems) {
    return JSON.parse(storedMenuItems);
  }
  return [];
};

export const setMenuItems = (menuItems) => {
  sessionStorage.setItem(MENU_STORAGE_KEY, JSON.stringify(menuItems));
};

export const clearMenuItems = () => {
  sessionStorage.removeItem(MENU_STORAGE_KEY);
};
